export function request(url, data = null, type = "POST", parse = true, needOverlay = true) {
	return new Promise((succeed, fail) => {
		$.ajax({
			url,
			data,
			type,
			beforeSend: () => {
				if (needOverlay) {
					$("#js-overlay").show();
				}
			},
			success: response => {
				if (response) {
					if (parse) {
						succeed(JSON.parse(response));
					} else {
						succeed(response);
					}
				} else {
					succeed();
				}
			},
			complete: () => {
				$("#js-overlay").hide();
			},
			error: error => {
				fail(new Error(`Request failed: ${error}`));
			},
		});
	});
}
